/**
 * Base entity model. All Apollon models should inherit this class.
 *
 * This file is part of Zeus Apollon
 *
 * (c) Kaden und Partner AG
 */
import { BaseModel } from '@/models/BaseModel';
import type { MutationsObject } from '@kp/js-model';

export class Foerderkategorie extends BaseModel {
    id: number | null = null
    aktiv: boolean = false
    reihenfolge: number | null = null
    foerderkategorie: string | null = null
    foerderkategorie_kurz: string | null = null
    bemerkung: string | null = null
    gesuchsvorlage_id: number | null = null
    kuerzel_gesuchsnummer: string | null = null
    ordnungsposition_fabasoft: string | null = null
    hide_objekt: boolean = false
    verknuepfung_waermenetzanschluss: boolean = false
    foerderkategorie_gruppe_id: number | null = null
    hilfetext: string | null = null
    show_in_map: boolean = false
    farbe_wms: string | null = null
    direkt_indirekt: string | null = null
    ist_waermenetzanschluss: boolean = false

    foerderkategorie_gruppe: string | null = null
    gesuchsvorlage: string | null = null

    public mutations(): MutationsObject {
        return {
            id: (id) => (Number(id) > 0 ? Number(id) : null)
        };
    }

    getClassName(): string {
        return 'foerderkategorie';
    }
}
